export default __webpack_public_path__ + "static/media/Awards_Shapes-03.fb2275cd.png";